import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetModulesInput, ModuleInput, ModuleResult, Result, ResultList } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class ModuleService {

  constructor(private httpClient: HttpClient) { }

  public addModule(moduleInput: ModuleInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'Module/AddModule', moduleInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editModule(id: number, moduleInput: ModuleInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'Module/EditModule?id=' + id, moduleInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteModule(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'Module/DeleteModule?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getModules(getModulesInput: GetModulesInput): Promise<ResultList<ModuleResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'Module/GetModules', getModulesInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<ModuleResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<ModuleResult>(), result.error));
  }
}
